import { render, staticRenderFns } from "./WxQrcode.vue?vue&type=template&id=6958bfe0&scoped=true"
import script from "./WxQrcode.vue?vue&type=script&lang=js"
export * from "./WxQrcode.vue?vue&type=script&lang=js"
import style0 from "./WxQrcode.vue?vue&type=style&index=0&id=6958bfe0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6958bfe0",
  null
  
)

export default component.exports